module.exports = __webpack_public_path__ + "img/40_69_011_900.c18a056c.jpg";